import transform from '../../../utils/ResponseTransformator'
import mapResponseToServices from '../mappers/mapResponseToServices'

export default async function(response: Response) {
  let text: string = await response.text()
  text = transform(text)
  const json: IData = JSON.parse(text)
  const services = json.items.map(mapResponseToServices)

  return services
}

export interface IData {
  messages: string[]
  items: IServicesData[]
}

export interface IServicesData {
  id: number
  id_user: number
  service_name: string
  price: number
  default: number
  hidden: number
  first_tax: string
  second_tax: string
}
